import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import getFocusedFilterForTable from 'mini-mail-list-store/lib/utils/getFocusedFilterForTable';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import listViewStore from 'mini-mail-list-store/lib/store/Store';
import NativeAdUserFlight from 'mini-mail-nativead-userchecker/lib/NativeAdUserFlight';
import { getNativeAdShowStatus } from 'mini-mail-nativead-userchecker/lib/getNativeAdShowStatus';
import { getStore } from 'mini-mail-nativeadlist-store/lib/store/store';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';
import { TableQueryType } from 'mini-mail-list-store/lib/store/schema/TableQuery';
import type TableView from 'mini-mail-list-store/lib/store/schema/TableView';

/**
 *  We should show the message Ad list when all of the following conditions are true:
 *   0. Consumer user!
 *   1. Host app does not support ads
 *   2. The Ad list is already removed by the user (except the Ad is a banner ad format)
 *   3. For all Inbox flight, make sure Folder is NOT drafts, sentitems, deleteditems, junkemail, archive, conversationhistory, notes
 *   4. Search does not run
 * @param tableView
 * @returns
 */
export const getNativeAdUserFlight = (tableView: TableView): NativeAdUserFlight => {
    if (!isConsumer()) {
        return NativeAdUserFlight.NoNativeAd;
    }

    if (!isMiniHostAppFeatureEnabled('ads')) {
        return NativeAdUserFlight.NoNativeAd;
    }

    const loadInOtherPivot = getFocusedFilterForTable(tableView) === FocusedViewFilter.Other;

    let thisListAdRemoved;

    // When miniAE-RemoveAdHonorList-treatment is enabled, we will honor the list where the ad is removed.
    // If the ad is removed from the other pivot, we only hide the ad in the other pivot
    // If the ad is removed from the primary/focus pivot, we only hide the ad in the primary/other pivot
    // Without this flight is enabled, we will use the current behavior
    // When the ad is removed from any pivot, we will hide the Ad for the whole session.
    if (isMiniFeatureEnabled('miniAE-RemoveAdHonorList-treatment')) {
        thisListAdRemoved =
            getStore() &&
            ((getStore().otherListAdRemoved && loadInOtherPivot) ||
                (getStore().primaryFocusListAdRemoved && !loadInOtherPivot));
    } else {
        thisListAdRemoved =
            getStore() && (getStore().otherListAdRemoved || getStore().primaryFocusListAdRemoved);
    }

    // For banner Ad, we do not look at the removal status as banner ad cannot be removed by the user
    if (thisListAdRemoved && getNativeAdShowStatus() !== NativeAdUserFlight.PrebidMobileBannerAd) {
        return NativeAdUserFlight.NoNativeAd;
    }

    if (
        getNativeAdShowStatus() !== NativeAdUserFlight.NoNativeAd &&
        tableView.tableQuery.folderId !== folderNameToId('drafts') &&
        tableView.tableQuery.folderId !== folderNameToId('sentitems') &&
        tableView.tableQuery.folderId !== folderNameToId('deleteditems') &&
        tableView.tableQuery.folderId !== folderNameToId('junkemail') &&
        tableView.tableQuery.folderId !== folderNameToId('conversationhistory') &&
        tableView.tableQuery.folderId !== folderNameToId('notes') &&
        tableView.tableQuery.folderId !== folderNameToId('archive') &&
        listViewStore != null &&
        !listViewStore.shouldShowSearchBox &&
        tableView.tableQuery.type !== TableQueryType.Search
    ) {
        return getNativeAdShowStatus();
    } else {
        return NativeAdUserFlight.NoNativeAd;
    }
};
